export enum MessageDisplayPreference {
  CollapseAll = 'collapse_all',
  ExpandAll = 'expand_all',
  ExpandLatest = 'expand_latest',
}

export function normalizeMessageDisplayPreference(value: unknown): MessageDisplayPreference {
  switch (value) {
    case MessageDisplayPreference.CollapseAll:
    case MessageDisplayPreference.ExpandAll:
    case MessageDisplayPreference.ExpandLatest:
      return value
    default:
      return MessageDisplayPreference.ExpandLatest
  }
}

export function shouldCollapseMessage(preference: MessageDisplayPreference, index: number): boolean {
  switch (preference) {
    case MessageDisplayPreference.CollapseAll:
      return true
    case MessageDisplayPreference.ExpandAll:
      return false
    default:
      return index > 0
  }
}
